import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./app/router/router";

import "./lib/config/LocaleConfig/i18n";
import "./app/globals.css";
import "./app/wrapper.css";

const root = createRoot(document.getElementById("root")!);
root.render(
  (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  ) as any,
);
